// Narrow swath value for the synthetic FlightResponse — we don't render spray polygons
// for the planner preview, so the value only needs to be non-zero and valid.
export const SYNTHETIC_SWATH_METERS = 1;
